module.exports = __webpack_public_path__ + "img/content_make9.8a6538f1.png";